export default __webpack_public_path__ + "static/media/sticker_white.adb3c6ef.png";